<!-- TRANSACTION LIST -->
<ng-container *ngIf="!isTransactionView">
  <mat-tab-group #statusTabGroup *ngIf="!isLive && authService.user.supportsYbo" mat-align-tabs="left" class="tabs no-body max-width top-spacer bottom-spacer"
                 [(selectedIndex)]="tab" (selectedIndexChange)="changeTab()">
    <mat-tab [label]="'general.api_transactions_new_events' | translate"></mat-tab>
    <mat-tab [label]="'general.api_transactions_legacy_events' | translate"></mat-tab>
  </mat-tab-group>
  <!-- FILTERS -->
  <app-transactions-filters
    [(filters)]="filters" [(showMobileFilters)]="showMobileFilters"
    [isLoading]="isLoading" [noSearches]="noSearches"
    [hasResults]="!!results?.transactions?.length" [legacyFilters]="tab === 1"
    (search)="search()"></app-transactions-filters>
  <!-- TABLE -->
  <ng-container *ngIf="!isLoading && results.transactions.length && (!showMobileFilters || !utilService.isMobile)">
    <mat-card appearance="outlined" [ngClass]="{'top-spacer-x2': utilService.isMobile}">
      <app-pagination *ngIf="!utilService.isMobile" [page]="page" [pageSize]="pageSize" [total]="results.total" [onTop]="true" (pageChange)="search($event)"></app-pagination>
      <div class="flex">
        <mat-form-field class="dynamic-width">
          <mat-label>{{'general.api_sort_by' | translate}}:</mat-label>
          <mat-select [(ngModel)]="sortBy" [ngModelOptions]="{standalone: true}" (ngModelChange)="updateLocalStorage()">
            <mat-select-trigger>{{displaySortWith(sortBy) | translate}}</mat-select-trigger>
            <mat-option *ngFor="let sortByOption of sortByOptions" [value]="sortByOption.id">
              {{sortByOption.title | translate}}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field class="dynamic-width">
          <mat-label>{{'general.api_search_display' | translate}}:</mat-label>
          <mat-select [(ngModel)]="pageSize" [ngModelOptions]="{standalone: true}" (ngModelChange)="updateLocalStorage()">
            <mat-select-trigger>{{pageSize}}</mat-select-trigger>
            <mat-option *ngFor="let pageSizeValue of pageSizeOptions" [value]="pageSizeValue">
              {{pageSizeValue}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <ng-container *ngIf="!utilService.isMobile">
        <app-data-table [(data)]="results.transactions" [(config)]="dataTableConfig"></app-data-table>
        <app-pagination [page]="page" [pageSize]="pageSize" [total]="results.total" (pageChange)="search($event)"></app-pagination>
      </ng-container>
      <ng-container *ngIf="utilService.isMobile">
        <hr class="slim">
        <div>
          <div class="listing-block" *ngFor="let transaction of results.transactions; let index = index">
            <div class="header-block flex space-between bottom-spacer">
              <div>
                <div class="heading-5 no-margin bold link">
                  <a (click)="$event.stopPropagation(); openTransaction(transaction)"><span>{{'general.api_reports_transaction_id' | translate}} {{transaction.id}}</span></a>
                </div>
                <span class="bold">{{transaction.date | moment: {format: viewService.conf.dateFormat, local: false} }}
                  {{transaction.date | moment: {format: viewService.conf.timeFormatWithSeconds, local: false} }}</span>
              </div>
              <div>
                <button mat-button class="icon-button input-button right-spacer"
                        *ngIf="!invoiceGenerateInProgress && !transaction.invoiceUuid && authService.checkPrivileges(Privileges.INVOICE_GENERATE)"
                        (click)="$event.stopPropagation(); openGenerateInvoiceModal(transaction)"
                        [matTooltip]="'general.api_transactions_generate_invoice' | translate">
                  <mat-icon class="svg-icon" [svgIcon]="'invoice'"></mat-icon>
                </button>
                <button mat-button color="accent" class="icon-button input-button right-spacer"
                        *ngIf="!invoiceGenerateInProgress && transaction.invoiceUuid"
                        (click)="$event.stopPropagation(); openGenerateInvoiceModal(transaction)"
                        [matTooltip]="invoiceViewEditTranslation">
                  <mat-icon class="svg-icon" [svgIcon]="'invoice'"></mat-icon>
                </button>
                <button mat-button class="icon-button input-button" (click)="$event.stopPropagation(); openTransaction(transaction)">
                  <mat-icon class="svg-icon" [svgIcon]="'arrow_right'"></mat-icon>
                </button>
              </div>
            </div>
            <table class="mobile-max-width mobile-columns">
              <tbody>
              <tr>
                <td>
                  <span class="bold">{{'general.api_reports_payment_type' | translate}}</span>
                  <ng-container *ngIf="isLegacy">
                    <br><span class="medium">{{'general.api_reports_release_type' | translate}}</span>
                  </ng-container>
                </td>
                <td class="align-right">
                  <span class="medium">{{ transaction.payments | paymentType }}</span>
                  <ng-container *ngIf="isLegacy && transaction.releaseType">
                    <br>{{('general.api_cart_release_method_' + transaction.releaseType) | translate}}
                  </ng-container>
                </td>
              </tr>
              <tr>
                <td>
                  <span class="bold">{{'general.api_reports_buyer' | translate}}</span>
                </td>
                <td class="align-right">
                  <span class="medium">
                    {{transaction.customer?.firstName}} {{transaction.customer?.lastName}}
                  </span>
                </td>
              </tr>
              <tr *ngIf="transaction.customer?.email">
                <td>
                  <span class="medium">{{'general.api_reports_buyer_email' | translate}}</span>
                </td>
                <td class="align-right">
                  {{transaction.customer.email}}
                </td>
              </tr>
              <tr *ngIf="transaction?.email && transaction.email !== transaction.customer?.email">
                <td>
                  <span class="medium">{{'general.api_transactions_delivery_email' | translate}}</span>
                </td>
                <td class="align-right">
                  {{transaction.email}}
                </td>
              </tr>
              <tr>
                <td>
                  <span class="bold">{{'general.api_reports_event' | translate}}</span>
                  <br><span class="medium">{{'general.api_reports_event_date_start' | translate}}</span>
                </td>
                <td class="align-right">
                  <ng-container *ngIf="transactionsEventList[index].length > 0 && !expandedTransactions.includes(index) && transactionsEventList[index]">
                    <div class="medium overflow-ellipsis">{{transactionsEventList[index][0].name | translateValue}}</div>
                    <span>{{transactionsEventList[index][0].date | period: {hasTimeInPeriod: true} }}</span>
                    <span *ngIf="transactionsEventList[index].length > 1">
                      <br>
                      <a class="link bold" (click)="expandTransaction(index)">
                        {{'general.api_transactions_event_show_more' | translate}} {{'(' + (transactionsEventList[index].length - 1) + ')'}}
                      </a>
                    </span>
                  </ng-container>
                  <ng-container *ngIf="transactionsEventList.length > 0 && expandedTransactions.includes(index)">
                    <ng-container *ngFor="let event of transactionsEventList[index]; let last = last">
                      <div class="medium overflow-ellipsis">{{ event.name | translateValue }}</div>
                      <span>{{event.date | period: {hasTimeInPeriod: true} }}</span>
                      <hr class="extra-slim" *ngIf="!last">
                    </ng-container>
                    <br>
                    <a class="link bold" (click)="closeTransaction(index)">{{'general.api_transactions_event_show_less' | translate}}</a>
                  </ng-container>
                </td>
              </tr>
              <tr>
                <td class="align-right" colspan="2">
                  <ng-template #seatInfoTemplate let-item="item" let-firstItem="firstItem" let-lastItem="lastItem">
                    <div class="flex space-between">
                      <span class="bold">{{ 'general.api_cart_table_sector' | translate }}</span>
                      <span class="medium">{{ item.sectorName | translate }}</span>
                    </div>
                    <ng-template #rowTemplate let-item="item">
                      <div *ngIf="item.row" class="flex space-between">
                        <span class="medium white-space-no-wrap">{{ 'general.api_cart_table_row' | translate }}: {{ item.row }}</span>
                        <span>
                          <span class="medium">{{ 'general.api_cart_table_seat' | translate }}: </span>
                          <ng-container *ngFor="let seat of item.seats; let lastSeat = last">
                            {{ seat }}<ng-container *ngIf="!lastSeat">, </ng-container>
                          </ng-container>
                        </span>
                      </div>
                    </ng-template>
                    <app-show-more [inputItems]="item.rows" [inputTemplate]="rowTemplate" [maxItems]="3"></app-show-more>
                    <hr class="extra-slim faded" *ngIf="!(firstItem && lastItem)">
                  </ng-template>
                  <app-show-more [inputItems]="sectorsPerTransaction[index]" [inputTemplate]="seatInfoTemplate"
                                 [expandStrings]="{more: 'general.api_show_more_sectors', less: 'general.api_show_less_sectors'}"></app-show-more>
                </td>
              </tr>
              <tr>
                <td>
                  <span class="bold">{{'general.api_reports_seller' | translate}}</span>
                  <br><span class="medium">{{'general.api_reports_salespoint' | translate}}</span>
                </td>
                <td class="align-right">
                  <span class="medium">{{transaction.seller?.firstName}} {{transaction.seller?.lastName}}</span>
                  <br><span>{{transaction.salespoint?.name || '-'}}</span>
                </td>
              </tr>
              <tr *ngIf="isLegacy">
                <td>
                  <span class="bold">{{'general.api_transactions_table_reservation' | translate}}</span>
                </td>
                <td class="align-right">
                  <span class="medium">{{transaction.bookingNr}}</span>
                </td>
              </tr>
              </tbody>
            </table>
            <hr class="slim">
            <table class="mobile-max-width">
              <tbody>
              <tr>
                <td>
                  <span class="text-muted">{{'general.api_cart_table_items_total' | translate}}</span>
                  <br>
                  <h3 class="bold">{{transaction.cart.total.ticketQuantity}}</h3>
                </td>
                <td class="align-right">
                  <span class="text-muted">{{'general.api_transactions_table_total' | translate}}</span>
                  <br>
                  <h3 class="bold">{{transaction.cart.total.total | price}}</h3>
                </td>
              </tr>
              </tbody>
            </table>
            <hr class="no-margin">
          </div>
        </div>
      </ng-container>
    </mat-card>
    <app-pagination *ngIf="utilService.isMobile" [page]="page" [pageSize]="pageSize" [total]="results.total" (pageChange)="search($event)"></app-pagination>
  </ng-container>
</ng-container>
<!-- TRANSACTION DETAILS -->
<router-outlet></router-outlet>
<app-loader [loading]="isLoading"></app-loader>

<ng-template #tableTime let-item="item">
  <span class="title">{{item.date | moment: {local: false, format: viewService.conf.dateFormat} }}</span>
  {{item.date | moment: {format: viewService.conf.timeFormatWithSeconds, local: false} }}
</ng-template>

<ng-template #tablePaymentType let-item="item">
  <span class="title">{{ item.payments | paymentType }}</span>
</ng-template>
<ng-template #tableReleaseType let-item="item">
  <ng-container *ngIf="item.releaseType">
    <br>{{('general.api_cart_release_method_' + item.releaseType) | translate}}
  </ng-container>
</ng-template>
<ng-template #tablePaymentMethod let-item="item">
  <ng-container *ngIf="isTransferPaymentMethod(item.payments)">
    <br>{{item.payments | paymentMethod}}
  </ng-container>
</ng-template>

<ng-template #tableEvent let-index="index">
  <ng-container *ngFor="let event of transactionsEventList[index]; let last = last">
    <span class="title break-word">{{ event.name | translateValue }}</span>
    <br>{{event.date | period: {hasTimeInPeriod: true} }}
    <hr *ngIf="!last">
  </ng-container>
</ng-template>

<ng-template #tableCustomer let-item="item">
  {{item.customer?.firstName}} {{item.customer?.lastName}}
  <ng-container *ngIf="item.customer?.email"><br>{{item.customer.email}}</ng-container>
</ng-template>

<ng-template #tableSectors let-index="index">
  <ng-container *ngFor="let sectorInfo of sectorsPerTransaction[index]; let first = first; let rowIndex = index">
    <hr *ngIf="!first">
    {{sectorInfo.sectorName | translate}}
  </ng-container>
</ng-template>

<ng-template #tableRows let-index="index">
  <ng-container *ngFor="let sectorInfo of sectorsPerTransaction[index]; let first = first; let rowIndex = index">
    <hr *ngIf="!first">
    <ng-container *ngIf="!sectorInfo?.rows[rowIndex]?.row">
      &nbsp;
    </ng-container>
    <ng-container *ngFor="let row of sectorInfo.rows; let lastRow = last">
      {{row.row}}<br *ngIf="!lastRow">
    </ng-container>
  </ng-container>
</ng-template>

<ng-template #tableSeats let-index="index">
  <ng-container *ngFor="let sectorInfo of sectorsPerTransaction[index]; let first = first; let rowIndex = index">
    <hr *ngIf="!first">
    <ng-container *ngIf="!sectorInfo?.rows[rowIndex]?.row">
      &nbsp;
    </ng-container>
    <ng-container *ngFor="let row of sectorInfo.rows; let lastRow = last">
      <ng-container *ngIf="row.seats.length > 5">
        {{row.seats.slice(0, 3).join(', ')}}
        <span class="title text-secondary"
              [matTooltip]="row.seats.join(', ')">...{{'general.api_reservation_more_seats' | translate}}</span>
      </ng-container>
      <ng-container *ngIf="row.seats.length <= 5">
        {{row.seats.join(', ')}}
      </ng-container>
      <br *ngIf="!lastRow">
    </ng-container>
  </ng-container>
</ng-template>

<ng-template #tableSeller let-item="item">
  {{item.seller?.firstName}} {{item.seller?.lastName}}
</ng-template>

<ng-template #tableSalespoint let-item="item">
  <br>{{item.salespoint?.name || '-'}}
</ng-template>

<ng-template #tableTicketQuantity let-item="item">
  <b>{{item.cart.total.ticketQuantity}}</b>
</ng-template>

<ng-template #tableTotal let-item="item">
  <b>{{item.cart.total.total | price}}</b>
</ng-template>
